const descriptionsKey = Symbol("elDescriptions");
export { descriptionsKey };